<button
  mat-raised-button
  [class]="class"
  [color]="color"
  [disabled]="isDisabled"
  (click)="onClick($event)"
>
  <div class="button-content">
    <mat-spinner
      *ngIf="isLoading"
      diameter="20"
      class="button-spinner"
    ></mat-spinner>
    <span *ngIf="isLoading" class="button-text-loading">
      <ng-content></ng-content>
    </span>
    <span *ngIf="!isLoading">
      <ng-content></ng-content>
    </span>
  </div>
</button>
